export default __webpack_public_path__ + "static/media/talavera.b475cc6c.jpeg";